var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalDivider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M12 0a1 1 0 00-1 1v22a1 1 0 002 0V1a1 1 0 00-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11H5V8a.5.5 0 00-.854-.354l-4 4a.5.5 0 000 .708l4 4a.5.5 0 00.354.146.493.493 0 00.191-.038A.5.5 0 005 16v-3h3a1 1 0 000-2zM23.854 11.646l-4-4A.5.5 0 0019 8v3h-3a1 1 0 000 2h3v3a.5.5 0 00.309.462.493.493 0 00.191.038.5.5 0 00.354-.146l4-4a.5.5 0 000-.708z"
  }))));
}
export default SvgHorizontalDivider;